import React, { useState } from "react";
import "./adminLayout.scss";
import AdminSidebar from "../AdminSideBar/AdminSideBar";
import { Outlet } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";

const AdminLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <div className="admin-layout">
      {/* Backdrop overlay for mobile sidebar */}
      {isSidebarOpen && (
        <div
          className="sidebar-backdrop"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      <div className={`side-bar ${isSidebarOpen ? "open" : ""}`}>
        <AdminSidebar onClose={() => setIsSidebarOpen(false)} />
      </div>

      <div className="admin-main">
        <header className="admin-header">
          <button
            className="menu-toggle"
            onClick={() => setIsSidebarOpen(true)}
            aria-label="Open Sidebar"
          >
            <MenuIcon />
          </button>

          <div className="header-title">
            <h2>Cinnamon Lake House</h2>
          </div>

          <div className="header-meta">
            <span className="current-date">
              {new Date().toLocaleDateString("en-US", {
                weekday: "short",
                month: "short",
                day: "numeric",
              })}
            </span>
          </div>
        </header>

        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
